import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from 'react-frontier';
import API, { CDN_URL } from '../API';
import moment from 'moment';

var LoginResponse =()=>{
	var navigate = useNavigate();
	var [error, setError] = useState<string | null>(null);

	useEffect(()=>{
		var params = new URLSearchParams(window.location.search);
		var authToken = params.get('at');
		var expiration = Number(params.get('e'));
		var now = moment().unix()
		if(!authToken || !expiration || Number.isNaN(expiration) || expiration <= now + 30){
			setError('La autenticación expiró o no regresó un token válido.');
			return;
		}

		API.onLoginToken(authToken).then((response)=>{
			if(response.error){
				setError(response.message || 'No fue posible iniciar sesión.');
				return;
			}
			navigate('/check', { replace: true });
		}).catch(()=>{
			setError('Hubo un error inesperado al iniciar sesión.');
		});
	}, []);

	if(error) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<Header centered size="normal" text="No pudimos completar el acceso" subtext={error} iconName="face-frown-open" />
	</div>;

	return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0' }}>
		<img src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" style={{ borderRadius: 4, width: 100, height: 100, objectFit: 'contain' }} />
	</div>;
};

export default LoginResponse;
